// Generated by purs version 0.15.0
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Restaumatic_PromotionsEngine_Cart_CartData from "../Restaumatic.PromotionsEngine.Cart.CartData/index.js";
import * as Restaumatic_PromotionsEngine_ProductFilter from "../Restaumatic.PromotionsEngine.ProductFilter/index.js";
import * as Restaumatic_PromotionsEngine_Promotions_Promotion from "../Restaumatic.PromotionsEngine.Promotions.Promotion/index.js";
var isNeverPromotion = function (promotion) {
    return Data_Eq.eq(Restaumatic_PromotionsEngine_Promotions_Promotion.eqPromotionConditions)(Restaumatic_PromotionsEngine_Promotions_Promotion.promotionConditions(promotion))(new Restaumatic_PromotionsEngine_Promotions_Promotion.CartPromotion(Restaumatic_PromotionsEngine_Promotions_Promotion.Never.value));
};
var isDisplayOnlyPromotion = function (promotion) {
    return Data_Eq.eq(Restaumatic_PromotionsEngine_Promotions_Promotion.eqPromotionType)(Restaumatic_PromotionsEngine_Promotions_Promotion.promotionType(promotion))(Restaumatic_PromotionsEngine_Promotions_Promotion.InformationOnly.value);
};
var filterByValue = function (value) {
    return function (promotion) {
        var v = Restaumatic_PromotionsEngine_Promotions_Promotion.promotionConditions(promotion);
        if (v instanceof Restaumatic_PromotionsEngine_Promotions_Promotion.CartPromotion && v.value0 instanceof Restaumatic_PromotionsEngine_Promotions_Promotion.CartValue) {
            return Data_Ord.greaterThanOrEq(Data_Money_Rounded.ordMoney)(value)(v.value0.value0.minCartValue);
        };
        return true;
    };
};
var atLeast = function (reqItems) {
    return function (predicate) {
        return function (productItems) {
            return reqItems <= Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(Data_Array.filter(predicate)(productItems));
        };
    };
};
var containInFilter = function (productItems) {
    return function (productFilter) {
        return function (requiredItems) {
            return atLeast(requiredItems)(function (v) {
                return Restaumatic_PromotionsEngine_ProductFilter.inProductFilter(v)(productFilter);
            })(productItems);
        };
    };
};
var filterByProductFilter = function (productItems) {
    return function (promotion) {
        var v = Restaumatic_PromotionsEngine_Promotions_Promotion.promotionConditions(promotion);
        if (v instanceof Restaumatic_PromotionsEngine_Promotions_Promotion.ProductPromotion) {
            return containInFilter(productItems)(v.value0.productFilter)(v.value0.numRequiredItems);
        };
        return true;
    };
};
var shouldIncludePromotion = function (items) {
    return function (subtotal) {
        return function (promotion) {
            return !Restaumatic_PromotionsEngine_Promotions_Promotion.isLoyaltyPromotion(promotion) && (!Restaumatic_PromotionsEngine_Promotions_Promotion.isFirstOrderPromotion(promotion) && (!isNeverPromotion(promotion) && (!isDisplayOnlyPromotion(promotion) && (filterByValue(subtotal)(promotion) && filterByProductFilter(items)(promotion)))));
        };
    };
};
var filterPromotions = function (inputCartData) {
    return Data_Array.filter(shouldIncludePromotion(Restaumatic_PromotionsEngine_Cart_CartData.productItems(inputCartData))(Restaumatic_PromotionsEngine_Cart_CartData.calcSubtotalInputCartData(inputCartData)));
};
export {
    filterPromotions
};
//# sourceMappingURL=index.js.map
